export default class SkipSentryError extends Error {
  constructor(...params) {
    super(...params);

    this.name = 'SkipSentryError';
  }
}
